import { useState, useRef } from "react";
import {
  BackButton,
  MyProfileWrapper,
  MyProfileContainer,
  ProfileImage,
  ProfileInformation,
  MyProfileContentTemplate,
  Title,
  ProfileInformationWrapper,
} from "./style";
import { FiX, FiKey, FiLogOut, FiTrash2 } from "react-icons/fi";
import {
  BiCog,
  BiRefresh,
  BiShield,
  BiEnvelope,
  BiMessageSquareDetail,
  BiEditAlt,
  BiCheck,
} from "react-icons/bi";
import { FaLanguage } from "react-icons/fa";
import ChangePassword from "./ProfileComponents/ChangePassword";
import LogoutOption from "./ProfileComponents/Logout";

interface MyProfileProps {
  onCloseClick: () => void;
}

const MyProfile = ({ onCloseClick }: MyProfileProps) => {
  const defaultBioContent =
    "Greetings, I'm Mexzy, and it's a pleasure to be here with all of you.";

  const [editBioMode, setEditBioMode] = useState(false);
  const [editedContent, setEditedContent] = useState(defaultBioContent);
  const [changePasswordDOM, setChangePasswordDOM] = useState(false);
  const [LogoutDOM, setLogoutDOM] = useState(false);
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const handleEditClick = () => {
    setEditBioMode(true);

    if (textareaRef.current) {
      textareaRef.current.focus();
    }
  };

  const handleCheckClick = () => {
    if (editedContent.trim() !== "") {
      setEditBioMode(false);
    } else {
      setEditBioMode(false);
      setEditedContent(defaultBioContent);
    }
  };

  const handleChangePassword = () => {
    setChangePasswordDOM(true);
  };
  const handleCloseChangePassword = () => {
    setChangePasswordDOM(false);
  };

  const handleLogout = () => {
    setLogoutDOM(true);
  };
  const handleCloseLogout = () => {
    setLogoutDOM(false);
  };

  return (
    <>
      <MyProfileContainer>
        <BackButton>
          <button onClick={onCloseClick}>
            <FiX color="#000" />
          </button>
        </BackButton>
        <MyProfileWrapper>
          {changePasswordDOM ? (
            <>
              <ChangePassword closeChangePassword={handleCloseChangePassword} />
            </>
          ) : LogoutDOM ? (
            <>
              <LogoutOption closeLogout={handleCloseLogout} />
            </>
          ) : (
            <>
              <ProfileInformationWrapper>
                <ProfileImage>
                  <img src="image/user101.png" />
                  <div>
                    <span>mexzy</span>
                    <span>samuel meshach</span>
                  </div>
                </ProfileImage>
                <ProfileInformation>
                  <div>
                    <span>
                      <BiEnvelope size={22} />
                    </span>
                    <span>samuelwalter@yahoo.com</span>
                  </div>
                  <div>
                    <span>
                      <BiMessageSquareDetail size={22} />
                    </span>
                    {editBioMode ? (
                      <textarea
                        ref={textareaRef}
                        value={editedContent}
                        onChange={(e) => setEditedContent(e.target.value)}
                      />
                    ) : (
                      <span>{editedContent}</span>
                    )}
                    <span>
                      {editBioMode ? (
                        <button onClick={handleCheckClick}>
                          <BiCheck size={20} />
                        </button>
                      ) : (
                        <button onClick={handleEditClick}>
                          <BiEditAlt size={20} />
                        </button>
                      )}
                    </span>
                  </div>
                </ProfileInformation>
              </ProfileInformationWrapper>
              <MyProfileContentTemplate>
                <Title>customization</Title>
                <div>
                  <BiCog size={22} />
                  <span>theme preferences</span>
                </div>
                <div>
                  <BiShield size={22} />
                  <span>privacy setting </span>
                </div>
                <div>
                  <FaLanguage size={22} />
                  <span>language preferences </span>
                </div>
              </MyProfileContentTemplate>
              <MyProfileContentTemplate>
                <Title>chat settings</Title>
                <div>
                  <FiKey size={22} />
                  <span>coming soon</span>
                </div>
              </MyProfileContentTemplate>
              <MyProfileContentTemplate>
                <Title>security</Title>
                <div onClick={handleChangePassword}>
                  <FiKey size={22} />
                  <span>change password</span>
                </div>
                <div onClick={handleLogout}>
                  <FiLogOut size={22} />
                  <span>logout </span>
                </div>
                <div>
                  <FiTrash2 size={22} color="#ff0000" />
                  <span>delete account </span>
                </div>
              </MyProfileContentTemplate>
              <MyProfileContentTemplate>
                <Title>application information</Title>
                <div>
                  <BiRefresh size={22} color="#261f88c4" />
                  <span>version 1.00.1</span>
                </div>
              </MyProfileContentTemplate>{" "}
            </>
          )}
        </MyProfileWrapper>
      </MyProfileContainer>
    </>
  );
};

export default MyProfile;
